import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Currency } from '../../../models/currencies.model';
import { CurrenciesService } from '../../../services/currencies/currencies.service';

@Component({
  selector: 'app-currency-form',
  templateUrl: 'currencyForm.html',
  styles: ['label.required:after {top: 0}']
})

export class CurrencyFormComponent implements OnInit {
  @Output() currencyAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() currencyUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxCurrency: Currency;
  addEditForm: FormGroup;
  public fields: any;
  public invalidSubmit: boolean;

  constructor(
    private fb: FormBuilder,
    private currenciesSrv: CurrenciesService
  ) {}

  ngOnInit() {

    this.currenciesSrv.getFields().subscribe(res => {
      this.fields = res;
    });

    this.addEditForm = this.fb.group({
      'name': new FormControl(this.dialogBoxCurrency.name),
      'iso_code': new FormControl(this.dialogBoxCurrency.iso_code),
      'simbol': new FormControl(this.dialogBoxCurrency.simbol),
      'decimal': new FormControl(this.dialogBoxCurrency.decimal)
    });
  }

  saveOrUpdate(): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    let newData = {...this.dialogBoxCurrency, ...this.addEditForm.value};
    if (newData.id == null) {
      this.currencyAdded.emit(newData);
    } else {
      this.currencyUpdated.emit(newData);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/currencies/currencyForm.component.ts